import React, { FC } from "react";
import classNames from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MUITooltip, { TooltipProps } from "@material-ui/core/Tooltip";

export const Tooltip: FC<TooltipProps> = ({ children, classes, ...rest }) => {
    const inner = useStyles();
    return (
        <MUITooltip classes={{ ...classes, tooltip: classNames(inner.tooltip, classes?.tooltip) }} {...rest}>
            {children}
        </MUITooltip>
    );
};

const useStyles = makeStyles({
    tooltip: {
        textAlign: "left",
        fontSize: 12,
        textIndent: 0,
        lineHeight: "1.4",
        letterSpacing: "0.2px",
        display: "block",
        maxWidth: 300,
        paddingButton: 5,
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
    },
});

export default Tooltip;
